import script from "./DangerZoneCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DangerZoneCard.vue?vue&type=script&setup=true&lang=ts"

import "./DangerZoneCard.vue?vue&type=style&index=0&id=de89411e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de89411e"]])

export default __exports__